import * as base from './standard.theme';
import { font } from './fonts';
import light from './light.theme';
import * as effects from './effects';
import * as charts from './charts';
import * as media from './media';
export const styledTheme = { effects, color: light, font, ...charts, ...base, ...media };
